module.exports = __webpack_public_path__ + "img/security2-logo2.b7d730d1.png";